module.exports = __webpack_public_path__ + "static/media/vikala-icon.330f36c2.png";